import { formatCompact } from '@bonanza-social/toolkit/utils';
import { PromotionRewardTarget } from '../components/RegistrationOfferImage/RegistrationOfferImage.constants';

export const formatReward = (reward: {
  rewardTarget?: (typeof PromotionRewardTarget)[keyof typeof PromotionRewardTarget];
  rewardAmount?: number;
}) => {
  const { rewardTarget, rewardAmount } = reward;
  switch (rewardTarget) {
    case PromotionRewardTarget.FreeSpins:
      return `${rewardAmount} Free Spins`;
    case PromotionRewardTarget.Coins:
      return `${formatCompact(rewardAmount ?? 0)} Bonanza Coins`;
    case PromotionRewardTarget.InstantWheel:
      return `${rewardAmount} Wheel Spins`;
    case PromotionRewardTarget.Bonus:
      return `${rewardAmount} Bonus`;
    case PromotionRewardTarget.Cash:
      return `${rewardAmount}$`;
    default:
      return `${reward.rewardAmount} ${reward.rewardTarget}`;
  }
};
